export default "__VITE_ASSET__DmtSPJPb__"